// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 14) return "static/js/5fbc470179b3ff68ee3b.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"e892db33697e3871fb73","140":"82e7e3991c5aa9b5857f","141":"b9383910a589a7f99f17"}[chunkId] + ".chunk.js";
};